if(typeof node-fetch === 'undefined') { var e = new Error("Cannot find module 'node-fetch'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = node-fetch;